export default "__VITE_ASSET__Civ0$55g__"